import React from 'react';

/**
 * Nova brand assets.
 *
 * The mark is a minimalist "nova" star-burst rendered as pure inline SVG (no
 * external font dependency), and the wordmark uses the loaded brand label font
 * (Outfit) so typography stays crisp and consistent everywhere it's used.
 *
 * Brand blue: #0F62FE (matches the app's primary action colour).
 */

export const NovaMark = ({ className = '', color = '#0F62FE' }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    {/* primary four-point sparkle */}
    <path
      d="M16 1.5C17.25 11 21 14.75 30.5 16 21 17.25 17.25 21 16 30.5 14.75 21 11 17.25 1.5 16 11 14.75 14.75 11 16 1.5Z"
      fill={color}
    />
    {/* secondary accent burst */}
    <path
      d="M26.5 3.5C27.05 7.05 27.95 7.95 31.5 8.5 27.95 9.05 27.05 9.95 26.5 13.5 25.95 9.95 25.05 9.05 21.5 8.5 25.05 7.95 25.95 7.05 26.5 3.5Z"
      fill={color}
      opacity="0.5"
    />
  </svg>
);

export const NovaLogo = ({
  className = '',
  markClassName = 'h-8 w-8',
  textClassName = 'text-2xl',
  color = '#0F62FE',
}) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <NovaMark className={markClassName} color={color} />
    <span
      className={`font-label font-bold tracking-tight leading-none ${textClassName}`}
      style={{ color }}
    >
      Nova
    </span>
  </span>
);

export default NovaLogo;
